//= require window.requestanimationframe/requestanimationframe.js
//= require slick-carousel/slick/slick.js

$(function() {
  'use strict';

  var $heros = $('.js-hero');

  $heros.each(function (index, hero) {

    var $hero       = $(hero),
        $slider     = $hero.find('.js-hero-slider'),
        $progress   = $hero.find('.js-hero-progress'),
        $nav        = $hero.find('.js-hero-nav'),
        duration    = 8000,
        transition  = 800,
        time        = Math.floor(Date.now()),
        hasChanged  = false,
        isPaused    = false,
        timeout,
        delta,
        $track;

    $nav.on('mouseenter focusin', function (event) {
      isPaused = true;
    });
    $nav.on('mouseleave focusout', function (event) {
      isPaused = false;
    });

    $slider.on('init', function (event) {
      $track = $('.slick-track');
    });

    $slider.on('beforeChange', function (event) {
      time = Math.floor(Date.now());
      $track.removeClass('is-hovered');
    });

    $slider.on('afterChange', function (event) {
      time = Math.floor(Date.now());
      delta = 0;
    });

    $slider.slick({
      prevArrow: $hero.find('.js-hero-nav-prev'),
      nextArrow: $hero.find('.js-hero-nav-next'),
    });

    $nav.on('mouseenter focusin', function (event) {
      var transform = $track.css('transform').split(','),
          position = 4,
          direction = $(event.currentTarget).data('direction'),
          width = $(event.currentTarget).width();

      if(transform.length == 16) {
        position = 12;
      }

      clearTimeout(timeout);

      $track.addClass('is-hovered');

      transform[position] = parseInt(transform[position]) + width * direction;
      transform.join(',');

      $track.css('transform', transform);
    });
    $nav.on('mouseleave focusout', function (event) {
      $slider.slick('setPosition');

      timeout = setTimeout(function () {
        $track.removeClass('is-hovered');
      }, transition);
    });

    (function loop() {
      requestAnimationFrame(loop);

      var currentTime = Math.floor(Date.now()),
          progression;

      if(isPaused) {
        time = Math.floor(Date.now()) - delta;
      }

      delta = currentTime - time;
      progression = Math.round(delta * 1000 / duration) / 1000;

      $progress.css({
        "-webkit-transform": "scaleX(" + progression + ")",
        "-ms-transform": "scaleX(" + progression + ")",
        "transform": "scaleX(" + progression + ")"
      });

      if(delta >= duration) {
        $slider.slick('slickNext');
      }
    })();
  });
});
